import { FeatureFlagKey, isStaffPreviewingFlag } from "encamp-shared/src/featureFlags";
import { useMemo } from "react";

import { useCurrentUser } from "./useCurrentUser";
import { useTenant } from "./useTenant";

export function useStaffPreviewingFlag(flag: FeatureFlagKey | undefined): boolean {
  const { isStaff } = useCurrentUser();
  const { tenant } = useTenant();

  return useMemo(() => {
    if (!flag) {
      return false;
    }

    return isStaffPreviewingFlag(flag, tenant?.tenantConfigs, isStaff);
  }, [flag, isStaff, tenant?.tenantConfigs]);
}
